import React from 'react'
import { Create } from 'react-admin'

import VideosForm from './form'

export const VideosCreate = (props) => (
  <Create {...props}>
    <VideosForm isEdit={false} {...props} />
  </Create>
)

export default VideosCreate
